import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';

const InstructionVideoExpandableTable = (props) => (
  <Table
    columns={[
      {
        label: 'Locale',
        path: 'locale',
        width: '60px',
      },
      {
        label: 'Title',
        path: 'videoTitle',
      },
      {
        label: 'Link',
        path: 'videoLink',
        render: (cell, row) => (
          <a target="_blank" href={cell} rel="noreferrer noopener">
            {cell}
          </a>
        ),
      },
    ]}
    showTableCount={false}
    rows={props.data}
  />
);

const InstructionVideoList = (props) => (
  <Table
    fetching={props.items.loading}
    expandableComponent={(row) => <InstructionVideoExpandableTable data={row.instructions} />}
    columns={[
      {
        label: 'Type',
        path: 'type',
        sort: true,
      },
      {
        label: 'Key',
        path: 'key',
        sort: true,
      },
      {
        label: 'Actions',
        path: 'action',
        width: '90px',
        render: (cell, row) => {
          return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button icon="edit" onClick={() => browserHistory.push(`/instruction-videos/${row.id}`)} />
              <Button icon="delete" onClick={() => props.onDelete(row)} />
            </div>
          );
        },
      },
    ]}
    rows={props.items}
    pagination={props.pagination}
    onDelete={props.onDelete}
  />
);

InstructionVideoList.propTypes = {
  onDelete: PropTypes.func,
  items: PropTypes.array,
  loading: PropTypes.bool,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    pageSize: PropTypes.number,
    total: PropTypes.number,
  }),
};

InstructionVideoList.defaultProps = {
  items: [],
  loading: false,
};

export default InstructionVideoList;
